import { LargeVisionActionTypes } from '../../../../../actions/dashboards'
import { Metrics } from '../../../../../constants/Dashboards'
import buildAsyncStatReducer from '../../asyncStatReducer'
import { TopStores } from '../../types'
import { StoresTopPayload } from '../../types'

/**
 * WFH Top Stores reducer
 */
const largeVisionStoresTop = buildAsyncStatReducer({
    key: Metrics.LARGEVISION_STORES_TOP,
    types: {
        request: LargeVisionActionTypes.DASHBOARD_LARGEVISION_STORES_TOP.request,
        success: LargeVisionActionTypes.DASHBOARD_LARGEVISION_STORES_TOP.success,
        failure: LargeVisionActionTypes.DASHBOARD_LARGEVISION_STORES_TOP.failure,
    },
    transform: (state, { payload }): TopStores => {
        return payload.map(({ store_code: storeCode, count }: StoresTopPayload) => ({
            storeCode,
            count,
        }))
    },
})

export default largeVisionStoresTop
